import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { Button, scheduleQueryKeys } from "toptaal-shared"
import { CalendarWithModal } from "@/components/modals/calendar/CalendarWithModal"
import {
  fetchGroupAllSchedule,
  fetchGroupSchedule,
} from "@/api/services/groups"
import RoleBasedComponent from "@/components/RolebasedComponent"

export const Route = createFileRoute("/beheer/groepen/$groupId/lessen/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const router = useRouter()
  const { groupId } = useParams({ from: "/beheer/groepen/$groupId" })

  const handleNavigate = () => {
    router.navigate({
      to: "/beheer/groepen/$groupId/lessen/nieuwe-les",
      params: { groupId: String(groupId) },
    })
  }

  return (
    <CalendarWithModal
      id={Number(groupId)}
      getQueryKey={scheduleQueryKeys.group}
      queryFn={({ id, startDate, endDate }) =>
        fetchGroupSchedule({ id, startDate, endDate })
      }
      getAllScheduleQueryKey={scheduleQueryKeys.groupAllSchedule}
      getAllScheduleQueryFn={({ id }) => fetchGroupAllSchedule({ id })}
      actionButton={
        <RoleBasedComponent entity="groups" permissions="create">
          <Button onClick={handleNavigate}>Les toevoegen</Button>
        </RoleBasedComponent>
      }
    />
  )
}
